/* eslint-disable react/display-name */

import moment from 'moment'
import { FC, ReactElement, useEffect, useMemo, useRef } from 'react'
import { DOMContainer } from 'react-overlays/esm/useWaitForDOMRef'
import Overlay from 'react-overlays/Overlay'
import Table from '../../components/table'
import { Patient } from '../../externals/api/patients'
import { usePatients } from '../../hooks/patients'
import { PatientListInfo } from '../patients/style'
import { PatientOverlayCard, PatientOverlayContainer } from './style'

export type PatientOverlayProps = {
  target?: DOMContainer<HTMLElement> | null
  onSelect?: (id: string) => void
  onHide?: () => void
}

const PatientOverlay: FC<PatientOverlayProps> = ({ onHide, onSelect, target }): ReactElement | null => {
  const containerRef = useRef<HTMLDivElement>(null)
  const { getList, patientsList } = usePatients()

  useEffect(() => {
    getList()
  }, [getList])

  const columns = useMemo(() => {
    return [
      {
        title: 'Nome paciente',
        dataIndex: 'name',
        render: (name: string, { _id, totalAnalysedExams }: Patient) => (
          <PatientListInfo onClick={() => onSelect && onSelect(_id)}>
            {name}
            <span>{totalAnalysedExams || 0} processamentos</span>
          </PatientListInfo>
        )
      },
      {
        title: 'Data do último processamento',
        dataIndex: 'createdAt',
        render: (createdAt: string) => moment(createdAt).format('DD/MM/YYYY')
      }
    ]
  }, [])

  if (!target) return null

  return (
    <PatientOverlayContainer ref={containerRef}>
      <Overlay
        show
        rootClose
        onHide={onHide}
        container={containerRef}
        target={target}
        placement='bottom'
        offset={[0, 10]}
      >
        {({ props }) => (
          <PatientOverlayCard {...props}>
            <Table
              size='sm'
              columns={columns}
              data={patientsList}
            />
          </PatientOverlayCard>
        )}
      </Overlay>
    </PatientOverlayContainer>
  )
}

export default PatientOverlay
